"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIUNavigationItems = void 0;
var navigation_1 = require("../../../types/navigation");
var navigation_2 = require("../../navigation");
var programFamilies_1 = require("../../programFamilies");
// TODO: fix the eslint-disable-line
// eslint-disable-next-line complexity
var getIUNavigationItems = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var programFamily = _a.programFamily;
    var bottom = [navigation_2.navigationItems.dataPrivacy, navigation_2.navigationItems.legal];
    switch (programFamily) {
        case programFamilies_1.ProgramFamily.BS: {
            return _b = {},
                _b[navigation_1.NavigationType.SIDE] = [
                    navigation_2.navigationItems.home,
                    navigation_2.navigationItems.calendar,
                    navigation_2.navigationItems.learn,
                    navigation_2.navigationItems.news,
                    navigation_2.navigationItems.community,
                    navigation_2.navigationItems.studyManagement,
                    navigation_2.navigationItems.infoCenter,
                    navigation_2.navigationItems.faq,
                ],
                _b[navigation_1.NavigationType.BOTTOM] = bottom,
                _b;
        }
        case programFamilies_1.ProgramFamily.DMSD:
        case programFamilies_1.ProgramFamily.DS:
        case programFamilies_1.ProgramFamily.VFS:
        case programFamilies_1.ProgramFamily.QS: {
            return _c = {},
                _c[navigation_1.NavigationType.SIDE] = [
                    navigation_2.navigationItems.home,
                    navigation_2.navigationItems.schedule,
                    navigation_2.navigationItems.learn,
                    navigation_2.navigationItems.news,
                    navigation_2.navigationItems.studyManagement,
                    navigation_2.navigationItems.infoCenter,
                    navigation_2.navigationItems.faq,
                ],
                _c[navigation_1.NavigationType.BOTTOM] = bottom,
                _c;
        }
        // Upskilling
        case programFamilies_1.ProgramFamily.ALO:
        case programFamilies_1.ProgramFamily.B2B:
        case programFamilies_1.ProgramFamily.B2C: {
            return _d = {},
                _d[navigation_1.NavigationType.SIDE] = [
                    navigation_2.navigationItems.home,
                    navigation_2.navigationItems.calendar,
                    navigation_2.navigationItems.learn,
                    navigation_2.navigationItems.news,
                    navigation_2.navigationItems.community,
                    navigation_2.navigationItems.trainingOrganization,
                    navigation_2.navigationItems.infoCenter,
                    navigation_2.navigationItems.faq,
                ],
                _d[navigation_1.NavigationType.BOTTOM] = bottom,
                _d;
        }
        case programFamilies_1.ProgramFamily.DWB: {
            return _e = {},
                _e[navigation_1.NavigationType.SIDE] = [
                    navigation_2.navigationItems.home,
                    navigation_2.navigationItems.calendar,
                    navigation_2.navigationItems.learn,
                    navigation_2.navigationItems.news,
                    navigation_2.navigationItems.community,
                    navigation_2.navigationItems.trainingOrganization,
                    navigation_2.navigationItems.infoCenter,
                ],
                _e[navigation_1.NavigationType.BOTTOM] = bottom,
                _e;
        }
        case programFamilies_1.ProgramFamily.CS: {
            return _f = {},
                _f[navigation_1.NavigationType.SIDE] = [
                    navigation_2.navigationItems.home,
                    navigation_2.navigationItems.learn,
                    navigation_2.navigationItems.news,
                    navigation_2.navigationItems.infoCenter,
                    navigation_2.navigationItems.faq,
                ],
                _f[navigation_1.NavigationType.BOTTOM] = bottom,
                _f;
        }
        // FS and rest of known program families - save for LI & LIBF
        // as those are on an entirely different instance
        // TODO: This matches the previous behavior, but we should check if they all belong here.
        case programFamilies_1.ProgramFamily.FS:
        case programFamilies_1.ProgramFamily.OS:
        case programFamilies_1.ProgramFamily.OI:
        case programFamilies_1.ProgramFamily.EU: {
            return _g = {},
                _g[navigation_1.NavigationType.SIDE] = [
                    navigation_2.navigationItems.home,
                    navigation_2.navigationItems.learn,
                    navigation_2.navigationItems.news,
                    navigation_2.navigationItems.community,
                    navigation_2.navigationItems.studyManagement,
                    navigation_2.navigationItems.infoCenter,
                    navigation_2.navigationItems.faq,
                ],
                _g[navigation_1.NavigationType.BOTTOM] = bottom,
                _g;
        }
        case programFamilies_1.ProgramFamily.MS:
        case programFamilies_1.ProgramFamily.VC:
        case programFamilies_1.ProgramFamily.MSE: {
            return _h = {},
                _h[navigation_1.NavigationType.SIDE] = [
                    navigation_2.navigationItems.home,
                    navigation_2.navigationItems.schedule,
                    navigation_2.navigationItems.learn,
                    navigation_2.navigationItems.news,
                    navigation_2.navigationItems.community,
                    navigation_2.navigationItems.studyManagement,
                    navigation_2.navigationItems.infoCenter,
                    navigation_2.navigationItems.faq,
                ],
                _h[navigation_1.NavigationType.BOTTOM] = bottom,
                _h;
        }
        // Only show a minimal navigation if we don't know the program family
        default: {
            return _j = {},
                _j[navigation_1.NavigationType.SIDE] = [navigation_2.navigationItems.home],
                _j[navigation_1.NavigationType.BOTTOM] = bottom,
                _j;
        }
    }
};
exports.getIUNavigationItems = getIUNavigationItems;
